import type { DataViewDesignTokens } from '@primeuix/themes/types/dataview'

export default {
  root: {
    padding: '0',
    borderColor: '{content.border.color}',
    borderWidth: '1px',
    borderRadius: '4px',
  },
  footer: {
    color: '{content.color}',
    padding: '0.875rem 1.125rem',
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderWidth: '1px 0 0 0',
    borderRadius: '0 0 5px 5px',
  },
  header: {
    padding: '0.875rem 1.125rem',
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
    borderRadius: '5px 5px 0 0',
  },
  content: {
    color: '{content.color}',
    padding: '0',
    background: '{content.background}',
    borderColor: 'transparent',
    borderWidth: '0',
    borderRadius: '5px',
  },
  colorScheme: {
    dark: {
      header: {
        color: '{text.color}',
        background: '{surface.800}',
      },
    },
    light: {
      header: {
        color: '{text.color}',
        background: '{surface.50}',
      },
    },
  },
  paginatorTop: {
    borderColor: '{content.border.color}',
    borderWidth: '0 0 1px 0',
  },
  paginatorBottom: {
    borderColor: '{content.border.color}',
    borderWidth: '1px 0 0 0',
  },
} satisfies DataViewDesignTokens
